import { PickerClientFilterKey } from "../config/companies/config";

type PickerFilterContext = {
  formData: Record<string, any>;
};

type PickerFilter = (
  item: Record<string, any>,
  context: PickerFilterContext,
) => boolean;

const modelsBySelectedMake: PickerFilter = (item, { formData }) => {
  return item.make.name === formData.make.name;
};

const FILTERS: Record<PickerClientFilterKey, PickerFilter> = {
  modelsBySelectedMake,
};

export const applyPickerClientFilter = (
  data: any[],
  key: PickerClientFilterKey,
  context: PickerFilterContext,
) => {
  const filterFn = FILTERS[key];
  return data.filter((item) => filterFn(item, context));
};
